<div class="test-env-banner-container">
    <mat-icon>warning</mat-icon>

    <div class="test-env-text">
        WARNING : This is a testing environment. Please ensure you are capturing
        data on the correct platform.
    </div>
</div>
